import { useParams } from "react-router-dom";
import InvoicesService from "../../../../../../services/billing_services/processing/invoices.service";
import { TemplateTypes } from "../../../../../../enum/PaymentsViewComponentsType";
import ItemizedInvoiceTemplate from "../_components/invoice-template/ItemizedInvoiceTemplate";
import BulletInvoiceTemplate from "../_components/invoice-template/BulletInvoiceTemplate";
import ParagraphInvoiceTemplate from "../_components/invoice-template/ParagraphInvoiceTemplate";
import { useEffect, useState } from "react";
import execWebRequest from "../../../../../../utils/helpers/execWebRequest";
import InvoiceReceiptTemplatesService from "../../../../../../services/billing_services/setup_config/InvoiceReceiptTemplates.service";
import { getInvoiceDetails, getshouldUseStore, invoiceDetailsStore } from "../../../../../../store/invoiceDetails.store";
import { getUserData } from "../../../../../../store/user.store";
import { PaymentTemplateStyle } from "../../../../../../enum/PaymentTemplates";

export default function ViewInvoiceReceiptPage({
  backToInvoiceCreationStep,
  isUsedAsStep = false,
  recipient = null,
}) {
  const { id } = useParams();
  const [invoiceDetails, setinvoiceDetails] = useState({});
  const invoiceData = getInvoiceDetails();
  const shouldUseInvoiceStore = getshouldUseStore();
  const userData = getUserData();
  const useTemplateInvoiceProperty =
    invoiceDetailsStore.getState().useTemplateInvoiceProperty;

  // fetch invoice details
  const fetchInvoiceDetails = async () => {
    return execWebRequest({
      message: "Loading...",
      execute: () => InvoicesService.getInvoiceById(id),
      onSuccess(result) {
        setinvoiceDetails(result);
        if (result.templateId) fetchTemplateDetails(result);
        else
          setinvoiceDetails((prevState) => ({
            ...prevState,
            templateFeildOption: TemplateTypes.bulletPoints,
          }));
      },
    });
  };
  // this new logic will only apply to invoices with template ids. so in table only show for those with template ids
  const fetchTemplateDetails = async (invoiceDetails) => {
    return execWebRequest({
      message: "Loading...",
      execute: () =>
        InvoiceReceiptTemplatesService.getTemplatesByID(
          invoiceDetails.templateId
        ),
      onSuccess(res) {
        setinvoiceDetails((prevState) => ({
          ...prevState,
          templateFeildOption: res.fieldOption,
        }));
      },
    });
  };

  function mutateInvoiceDetails() {
    const subtotal = invoiceData?.templateInvoice?.invoiceLineItems?.reduce(
      (accumulator, currentValue) =>
        Number(accumulator) + Number(currentValue.amount),
      0
    );

    const discountTotal = invoiceData?.tempDiscounts?.reduce(
      (accumulator, currentValue) =>
        currentValue.amount
          ? accumulator + currentValue.amount
          : currentValue.percentage
          ? accumulator + (currentValue.percentage / 100) * subtotal
          : 0,
      0
    );
    const feesTotal = invoiceData?.fees?.reduce(
      (accumulator, currentValue) =>
        currentValue.amount
          ? accumulator + currentValue.amount
          : currentValue.percentage
          ? accumulator + (currentValue.percentage / 100) * subtotal
          : 0,
      0
    );

    return {
      ...invoiceData,
      amount: subtotal - discountTotal + feesTotal,
      discounts: invoiceData.tempDiscounts,
      lineItems: invoiceData.templateInvoice.invoiceLineItems,
      templateFeildOption:
        invoiceData.templateInvoice.templateFeildOption ??
        PaymentTemplateStyle.BulletPoints,
      issuerName: userData.fullName,
      issuerEmail: userData.email,
      issuerPhone: userData.phoneNumber,
      billerEntityName: recipient?.name,
      billerEntityEmail: recipient?.primaryContactEmailAddress,
      billerEntityPhone: recipient?.contact?.primaryPhoneNumber,
    };
  }


  useEffect(() => {
    if (!isUsedAsStep) fetchInvoiceDetails();
  }, []);

  useEffect(() => {
    // if page should fetch invoice date then fetch else fetch details from store

    if (shouldUseInvoiceStore) {
      setinvoiceDetails(
        useTemplateInvoiceProperty ? mutateInvoiceDetails() : invoiceData
      );
      if (useTemplateInvoiceProperty) {
        setinvoiceDetails((prevState) => ({
          ...prevState,
          discounts: invoiceData.tempDiscounts,
        }));
      }
      // if (!invoiceData.templateId) {
      //  return setinvoiceDetails((prevState) => ({
      //    ...prevState,
      //    templateFeildOption: TemplateTypes.bulletPoints,
      //  }));
      // }
    } else {
      return fetchInvoiceDetails();
    }

    return () => {
      invoiceDetailsStore.getState().setshouldUseStore(false);
      invoiceDetailsStore.getState().setuseTemplateInvoiceProperty(false);
    };
  }, []);
  return (
    // Render template based on type gfh
    <div>
      {invoiceDetails.templateFeildOption === TemplateTypes.itemizedTable && (
        <ItemizedInvoiceTemplate
          invoiceDetails={invoiceDetails}
          backToInvoiceCreationStep={() => backToInvoiceCreationStep()}
          isUsedAsStep={isUsedAsStep}
        />
      )}

      {invoiceDetails.templateFeildOption === TemplateTypes.bulletPoints && (
        <BulletInvoiceTemplate
          invoiceDetails={invoiceDetails}
          backToInvoiceCreationStep={() => backToInvoiceCreationStep()}
          isUsedAsStep={isUsedAsStep}
        />
      )}

      {invoiceDetails.templateFeildOption === TemplateTypes.paragraph && (
        <ParagraphInvoiceTemplate
          invoiceDetails={invoiceDetails}
          backToInvoiceCreationStep={() => backToInvoiceCreationStep()}
          isUsedAsStep={isUsedAsStep}
        />
      )}
    </div>
  );
}
